import { render, staticRenderFns } from "./DisparityDetailsPage.vue?vue&type=template&id=01853db8&scoped=true"
import script from "./DisparityDetailsPage.vue?vue&type=script&lang=js"
export * from "./DisparityDetailsPage.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DisparityDetailsPage.vue?vue&type=style&index=1&id=01853db8&prod&scoped=true&lang=css"
import style2 from "./DisparityDetailsPage.vue?vue&type=style&index=2&id=01853db8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01853db8",
  null
  
)

export default component.exports